// src/services/api.js

import { API_URL } from "../config";

// SUBJECTS
export const getSubjects = async (countryId = null) => {
  const url = countryId
    ? `${API_URL}/generalsubjects/?country=${countryId}`
    : `${API_URL}/generalsubjects/`;

  const tokenString = localStorage.getItem("authToken");
  const token = tokenString ? JSON.parse(tokenString) : null;

  const res = await fetch(url, {
    headers: token?.access
      ? {
          Authorization: `Bearer ${token.access}`,
        }
      : {},
  });

  if (!res.ok) {
    throw new Error("Failed to fetch subjects");
  }

  return res.json();
};

export const createSubject = async (data) => {
  const res = await fetch(`${API_URL}/generalsubjects/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return res.json();
};

export const updateSubject = async (id, data) => {
  const res = await fetch(`${API_URL}/generalsubjects/${id}/`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return res.json();
};

export const deleteSubject = async (id) => {
  await fetch(`${API_URL}/generalsubjects/${id}/`, {
    method: "DELETE",
  });
};

// EXAMS
export const fetchExams = async (countryId) => {
  const res = await fetch(`${API_URL}/admin/exams/${countryId}/`);

  if (!res.ok) {
    throw new Error("Failed to fetch exams");
  }

  return res.json();
};

// VIDEOS
export const getVideos = async (subjectId, examId = null) => {
  const tokenString = localStorage.getItem("authToken");
  const token = tokenString ? JSON.parse(tokenString) : null;

  let url = `${API_URL}/videos/?subject=${subjectId}`;

  if (examId) {
    url += `&exam=${examId}`;
  }

  const res = await fetch(url, {
    headers: token?.access
      ? {
          Authorization: `Bearer ${token.access}`,
        }
      : {},
  });

  if (!res.ok) {
    throw new Error("Failed to fetch videos");
  }

  return res.json();
};

export const createVideo = async (data) => {
  const res = await fetch(`${API_URL}/videos/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return res.json();
};

export const updateVideo = async (id, data) => {
  const res = await fetch(`${API_URL}/videos/${id}/`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return res.json();
};

export const deleteVideo = async (id) => {
  await fetch(`${API_URL}/videos/${id}/`, {
    method: "DELETE",
  });
};

export const deleteVideoCategory = async (id) =>
  await fetch(`${API_URL}/video-categories/${id}/`, {
    method: "DELETE",
  });



export const getVideo = async (id, examId = null) => {
  const tokenString = localStorage.getItem("authToken");
  const token = tokenString ? JSON.parse(tokenString) : null;

  let url = `${API_URL}/videos/${id}/play/`;

  if (examId) {
    url += `?exam=${examId}`;
  }

  const res = await fetch(url, {
    headers: token?.access
      ? {
          Authorization: `Bearer ${token.access}`,
        }
      : {},
  });

  if (!res.ok) {
    throw new Error("Failed to fetch video");
  }

  return res.json();
};

// GET categories
export const fetchVideoCategories = async () => {
  const res = await fetch(`${API_URL}/video-categories/`);
  return await res.json();
};

// GET online teacher
export const fetchOnlineStudents = async () => {
  const res = await fetch(`${API_URL}/online-students/`);
  return await res.json();
};



// CREATE category
export const createVideoCategory = async (body) => {
  const tokenString = localStorage.getItem("authToken");
  const token = JSON.parse(tokenString);
  const res = await fetch(`${API_URL}/video-categories/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token.access}`,
    },
    body: JSON.stringify(body),
  });
  return await res.json();
};

// UPDATE

export const updateVideoCategory = async (id, data) => {
  const res = await fetch(`${API_URL}/video-categories/${id}/`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  return await res.json();
};
// VIDEO STATS
export const fetchVideoStats = async (year, month) => {
  const tokenString = localStorage.getItem("authToken");
  const token = tokenString
    ? JSON.parse(tokenString)
    : null;

  const params = new URLSearchParams();

  if (year) {
    params.append("year", year);
  }

  if (month) {
    params.append("month", month);
  }

  const res = await fetch(
    `${API_URL}/video-stats/?${params.toString()}`,
    {
      headers: token?.access
        ? {
            Authorization: `Bearer ${token.access}`,
          }
        : {},
    }
  );

  if (!res.ok) {
    throw new Error("Failed to fetch video statistics");
  }

  return res.json();
};

export const fetchOnlineTeacherStats = async (
  year,
  month
) => {
  const tokenString = localStorage.getItem("authToken");
  const token = tokenString
    ? JSON.parse(tokenString)
    : null;

  const params = new URLSearchParams();

  if (year) {
    params.append("year", year);
  }

  if (month) {
    params.append("month", month);
  }

  const res = await fetch(
    `${API_URL}/online-teacher-stats/?${params.toString()}`,
    {
      headers: token?.access
        ? {
            Authorization: `Bearer ${token.access}`,
          }
        : {},
    }
  );

  if (!res.ok) {
    throw new Error("Failed to fetch teacher statistics");
  }

  return res.json();
};
export const resetWatchCount = async (token) => {
  const res = await fetch(`${API_URL}/reset-video-watch-count/`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) throw new Error("Reset failed");

  return res.status === 204 ? null : await res.json();
};
